import { render, staticRenderFns } from "./Realme5Series.vue?vue&type=template&id=1425b683&scoped=true&"
import script from "./Realme5Series.vue?vue&type=script&lang=js&"
export * from "./Realme5Series.vue?vue&type=script&lang=js&"
import style0 from "./Realme5Series.vue?vue&type=style&index=0&id=1425b683&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425b683",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VChip,VChipGroup,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
